import { SPECIFIC_ROLES_WITH_PROJECT_ADMIN_DATA } from 'utils/constants/specificRoles';

export const hasSpecificRoleWithProjectAdminData = (code) =>
  Object.keys(SPECIFIC_ROLES_WITH_PROJECT_ADMIN_DATA).includes(code);
